import { FC, useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import { filter, map, toString } from 'lodash-es';
import { browseActivitiesByPeriodsStyles } from './browse-activities-by-periods.styles';
import { useStyles } from '@sweatpals/react-ui-kit';
import { RANGES } from '@/modules/_core/constants';
import { RangeEnum } from '@/modules/_core/enums/range';
import ButtonsGroup from '@/modules/_core/components/inputs/button-group.component';

export interface BrowseActivitiesByPeriodsProps {
	selectedPeriod?: RangeEnum;
	onPeriodChange?(period: RangeEnum): void;
}

const BrowseActivitiesByPeriods: FC<BrowseActivitiesByPeriodsProps> = ({ selectedPeriod, onPeriodChange }) => {
	const styles = useStyles(browseActivitiesByPeriodsStyles);

	const periods = useMemo(() => {
		const keys = Object.keys(RANGES);
		const filteredKeys = filter(keys, (key) => key !== toString(RangeEnum.Custom));

		return map(filteredKeys, (key) => ({
			name: RANGES[key]().name,
			value: RANGES[key]().value,
		}));
	}, []);

	return (
		<Box sx={styles.root}>
			<Typography sx={styles.title}>browse your favorite activities</Typography>

			<ButtonsGroup
				items={periods}
				onChangeHandler={onPeriodChange}
				selectedItems={[selectedPeriod]}
				sx={{ rootSx: { flexWrap: 'wrap' } }}
			/>
		</Box>
	);
};

export default BrowseActivitiesByPeriods;
